module.exports = __webpack_public_path__ + "static/media/doc05.096b894f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/doc05.png
// module id = 57
// module chunks = 0